import React from "react";
import { Button } from "@mui/material";
import DownladIcon from "./../../../assets/svg/download.svg";
import { SideMenu, BackHeader } from "./../../components";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
let ResultView = (props) => {
  const navigate = useNavigate();
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <div className="view-result-data-main">
          <p className="view-result-title">Student Name: </p>
          <p className="view-result-description">Willow Anderson</p>
        </div>
        <div className="view-result-data-main">
          <p className="view-result-title">Class and Division:</p>
          <p className="view-result-description">Class 5th A</p>
        </div>
        <div className="view-result-data-main">
          <p className="view-result-title">Date:</p>
          <p className="view-result-description">03-03-2022</p>
        </div>
        <div className="view-result-data-main">
          <p className="view-result-title">Task name:</p>
          <p className="view-result-description">
            Nam ac velit eu magna placerat mattis sit amet et velit. Cras
            eleifend ante id aliquam sagittis.
          </p>
        </div>
        <div className="view-result-data-main">
          <p className="view-result-title">Rmarks</p>
        </div>
        <p className="view-result-description">
          Nam ac velit eu magna placerat mattis sit amet et velit. Cras eleifend
          ante id aliquam sagittis. Curabitur vitae neque neque. Phasellus et
          feugiat ex. Aenean ultricies est ut dignissim varius. Ut quis lacus
          auctor, faucibus neque scelerisque, tempus nunc. Maecenas consectetur
          purus sit amet nisl pharetra varius. Ut malesuada scelerisque purus,
          quis luctus dolor consectetur vel. Mauris lacinia neque ac ullamcorper
          scelerisque. Vestibulum elementum iaculis ex id ultricies. Phasellus a
          justo dolor. Sed quis ex nec risus mattis volutpat.
        </p>
        <br />
        <br />
        <Button>
          <img src={DownladIcon} />
        </Button>
      </div>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
          <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <Button
              className="form-button"
              variant="text"
              onClick={() =>
                navigate("/tutor-panel/result/edit")
              }
            >
            Edit Result 
            </Button>
          </Grid>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
        </Grid>
      </Box>
    </SideMenu>
  );
};
export default ResultView;
